import { sizeSort } from '../../utils';

export interface SizePriceColumn {
  label: string;
  price: number;
}

interface SkuSizePrice {
  size: string | null;
  price: number | null;
}

/**
 * Builds the popup's price table columns from per-sku prices.
 */
export function buildSizePriceColumns(skus: SkuSizePrice[]): SizePriceColumn[] {
  const priceBySize = new Map<string, number>();
  let fallbackPrice: number | null = null;
  for (const sku of skus) {
    if (null === sku.price) {
      continue;
    }
    if (null === fallbackPrice) {
      fallbackPrice = sku.price;
    }
    const size = (sku.size ?? '').trim();
    if ('' === size || priceBySize.has(size)) {
      continue;
    }
    priceBySize.set(size, sku.price);
  }

  if (null === fallbackPrice) {
    return [];
  }

  const distinct = Array.from(priceBySize.keys()).sort(sizeSort);
  if (0 === distinct.length) {
    return [{ label: '', price: fallbackPrice }];
  }

  const groups: { first: string; last: string; price: number }[] = [];
  for (const size of distinct) {
    const price = priceBySize.get(size)!;
    const lastGroup = groups[groups.length - 1];
    if (lastGroup && lastGroup.price === price) {
      lastGroup.last = size;
    } else {
      groups.push({ first: size, last: size, price });
    }
  }

  return groups.map((g) => ({
    label: g.first === g.last ? g.first : `${g.first}-${g.last}`,
    price: g.price,
  }));
}
